import {
    SPI,
    ActionType,
    BaseActionWidget,
    ReloadViewActionWidget,
    ViewType,
    Widget
} from '@kunlun/dependencies';
import {exportFile,getExportProgress} from '../../../api'
import syncExportComponent from './syncExport.vue'

@SPI.ClassFactory(
    BaseActionWidget.Token({
        viewType: ViewType.Table,
        actionType: ActionType.Client,
        name: '$$internal_ReloadData',
        model: ["deli.aries.seller.SellerDistributionTradeOrderDetail","aries.trade.DeliAriesBuyerTradeOrderDetail","aries.trade.DeliAriesBuyerTradeOrder","aries.logistics.DeliAriesBuyerTmsOrder","deli.aries.merchant.DeliAriesBuyerTmsOrderDetail"],
        widget: 'ClientAction',
    })
)
export class syncExport extends ReloadViewActionWidget {
    initialize(props: any) {
        super.initialize(props);
        this.setComponent(syncExportComponent)
        return this;
    }


    @Widget.Method()
    async exportFile(exportId: string): Promise<any[]> {
        const condition = this.getSearchRsqlAndQueryParams();
        console.log(condition);
        return await exportFile(this.model, "exportSync" , condition, exportId);
    }


    @Widget.Method()
    async getExportProgress(exportId: string): Promise<any[]> {
        console.log(exportId);
        return await getExportProgress(exportId);
    }

}
